import BaseRepository from './BaseRepository';

export default class MemberReportsRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/member-reports';
    }

    loadSales()
    {
        return this.request('GET', `${this.getEndpoint()}/sales`, null);
    }

    loadNumberOfBookings()
    {
        return this.request('GET', `${this.getEndpoint()}/bookings`, null);
    }

    loadTopHotels(period = '')
    {
        return this.request('GET', `${this.getEndpoint()}/top-hotels/${period}`, null);
    }

    loadTopDestinations(period = '')
    {
        return this.request('GET', `${this.getEndpoint()}/top-destinations/${period}`, null);
    }

    getCommissionReceived({ includes })
    {
        const queryString = this.buildQueryString({
            includes,
        });
        return this.request('GET', `${this.getEndpoint()}/commission-received?${queryString}`);
    }

    getClosingRatio(memberId)
    {
        return this.request('GET', `${this.getEndpoint()}/${memberId}/closing-ratio`, null);
    }
}
